<template>
    <div class="consultar-empresa-list px-4">
        <div class="table-container">
            <b-table id="consultar-empresa-temp" striped responsive :items="rows" :fields="headerFields">
            </b-table>
        </div>
    </div>
</template>

<script>

let headerFields = [
    {key: 'razaoSocial', label: 'Razão Social'},
    {key: 'text', label: 'Nome Fantasia'},
    {key: 'cnpj', label: 'CNPJ'},
    {key: 'status', label: 'Status'},
]

let columnsKeys = [
    'status',
    'razaoSocial',
    'text',
    'codigo',
    'cnpj',
    'dataTermino',
]

export default {
    name: "ConsultarEmpresaList",
    props: {
		rows: Array
	},
    data() {
        return {
            headerFields: [
                ...headerFields.filter(head => columnsKeys.includes(head.key)),
            ],
            lastFilter: {},
            page: 1,
        }

    }
}
</script>
<style scoped>
.table-container .table-responsive {
	font-size: small;
}
</style>